module.exports = __webpack_public_path__ + "static/media/officemagProduct.65816c3c.jpeg";